import { render } from "./DetailsModal.vue?vue&type=template&id=4934f4a5&ts=true"
import script from "./DetailsModal.vue?vue&type=script&lang=ts"
export * from "./DetailsModal.vue?vue&type=script&lang=ts"

import "./DetailsModal.vue?vue&type=style&index=0&id=4934f4a5&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__